module.exports = __webpack_public_path__ + "img/avatar-9.d9f9fab1.jpg";